<template>
    <div id="home">
        <!--  搜索框  -->
        <SearchBar :data="searchBar" @searchHandle="searchHandle" @iconHandle="iconHandle"></SearchBar>
        <!--  轮播图  -->
        <SwipeBanner :data="bannerObj"></SwipeBanner>
        <div class="main-box">
            <!--  消息提醒  -->
<!--            <div v-for="(item, index) in noReadings" :key="index">-->
<!--                &lt;!&ndash; <div class="my-notice y-center" @click="noticeHandle" v-if="item.num > 0 && index == noticeActive" :style="{background:' linear-gradient(45deg, '+mainColorLight+', '+mainColorDarken+')'}">-->
<!--          <van-icon class="iconfont" class-prefix="icon" name="yinliang"></van-icon>您有{{ item.num>100? '99+' : item.num }}条新的{{ item.moduleKey == 'affiche'? '公告' : item.moduleKey == 'meeting'? '会议通知' : item.moduleKey == 'survey'? '调查' : '通知' }} >-->
<!--        </div> &ndash;&gt;-->

<!--                <div-->
<!--                    class="my-notice y-center"-->
<!--                    @click="noticeHandle"-->
<!--                    v-if="item.num > 0 && index == noticeActive"-->
<!--                    :style="{ background: ' linear-gradient(45deg, ' + mainColorLight + ', ' + mainColorDarken + ')' }"-->
<!--                >-->
<!--                    <van-icon class="iconfont" class-prefix="icon" name="yinliang"></van-icon>-->
<!--                    您有{{ item.num > 100 ? "99+" : item.num }}条新的消息 >-->
<!--                </div>-->
<!--            </div>-->
            <template v-if="noReading">
                <div
                    class="my-notice y-center"
                    @click="noticeHandle"
                    :style="{ background: ' linear-gradient(45deg, ' + mainColorLight + ', ' + mainColorDarken + ')' }"
                >
                    <van-icon class="iconfont" class-prefix="icon" name="yinliang"></van-icon>
                    您有{{ noReading > 100 ? "99+" : noReading }}条新的消息 >
                </div>
            </template>
            <template v-for="item in homeData">
                <!--   推荐服务   -->
                <RecommendedService
                    v-if="item.key == 'recommend'"
                    :title="item.name"
                    :key="item.id"
                ></RecommendedService>
                <!--  专题服务  -->
                <ThematicServices v-if="item.key == 'special'" :title="item.name" :key="item.id"></ThematicServices>
                <!--  直通部门  -->
                <DirectDepartment v-if="item.key == 'direct'" :title="item.name" :key="item.id"></DirectDepartment>
                <!--  服务资讯  -->
                <ServiceNews v-if="item.key == 'info'" :title="item.name" :key="item.id"></ServiceNews>
                <!--  便民服务  -->
                <ConvenienceServices
                    v-if="item.key == 'convenient'"
                    :title="item.name"
                    :key="item.id"
                ></ConvenienceServices>
                <!--  业务直通车  -->
                <ExpressCar v-if="item.key == 'express'" :title="item.name" :key="item.id"></ExpressCar>
                <!--  日程中心  -->
                <agendaCenter v-if="item.key == 'schedule'" :title="item.name" :key="item.id"></agendaCenter>
            </template>
        </div>
    </div>
</template>

<script>
import {getBanner, getHomeData, getUnreadMessageCount} from "@/api/home"
import {locationTo} from "@/utils/url"
import {getThemeParams} from "@/utils/theme"
import {fetchRgbColer} from "@/utils/commons"

export default {
        name: "Home",
        components: {
            SearchBar: () => import("@/components/Home/SearchBar"),
            SwipeBanner: () => import("@/components/Home/SwipeBanner"),
            RecommendedService: () => import("@/components/Home/RecommendedService"),
            ThematicServices: () => import("@/components/Home/ThematicServices"),
            DirectDepartment: () => import("@/components/Home/DirectDepartment"),
            ServiceNews: () => import("@/components/Home/ServiceNews"),
            ConvenienceServices: () => import("@/components/Home/ConvenienceServices"),
            ExpressCar: () => import("@/components/Home/ExpressCar"),
            agendaCenter: () => import("@/components/Home/agendaCenter"),
        },
        data() {
            return {
                homeData: [],
                list: [],
                //搜索框组件数据
                searchBar: {
                    title: "搜索您要办理的事项", // 标题
                    icon: "jiqiren", // icon的名称
                    hasBg: false, //是否有背景色
                    iconEmitCallback: "iconHandle", //图标点击事件回调函数名称
                    searchEmitCallback: "searchHandle",
                    qabotSwitch: false,
                },
                timer: "",
                //通知数量
                noReadings: [],
                noReading: 0,
                noticeActive: 0,
                bannerObj: {
                    intervalTime: 3000,
                    autoSwitch: false,
                    items: [],
                },
                fontSize: "中",
            }
        },
        computed: {
            mainColor() {
                if (getThemeParams("main_color")) {
                    return getThemeParams("main_color")
                } else {
                    return "#003c88"
                }
            },
            mainColorLight() {
                let rgb = fetchRgbColer(this.mainColor)
                rgb[0] += 20
                rgb[1] += 20
                rgb[2] += 20
                return "rgba(" + rgb.join(",") + ",1)"
            },
            mainColorDarken() {
                let rgb = fetchRgbColer(this.mainColor)
                rgb[0] -= 20
                rgb[1] -= 20
                rgb[2] -= 20
                return "rgba(" + rgb.join(",") + ",1)"
            },
        },
        created() {
            //window.history.pushState(null, null, document.URL)
            // 添加滚动监听事件
            this.$nextTick(() => {
                this.init()
                document.addEventListener("scroll", this.handleScroll)
            })
            // this.activated() // 监听浏览器返回
        },
        methods: {
            // goBack() {
            //     // 点击浏览器的返回触发的方法
            //     let timer = setTimeout(function () {
            //         document.addEventListener(
            //             "WeixinJSBridgeReady",
            //             function () {
            //                 WeixinJSBridge.call("closeWindow")
            //             },
            //             false
            //         )
            //         //这个可以关闭ios系统的手机
            //         WeixinJSBridge.call("closeWindow")
            //         clearInterval(timer)
            //         //这个可以关闭安卓系统的手机
            //     }, 300)
            //     this.$router.go(-2)
            // },
            // activated() {
            //     if (window.history && window.history.pushState) {
            //         history.pushState(null, null, document.URL)
            //         window.addEventListener("popstate", this.goBack, false)
            //     }
            // },
            // banner
            init() {
                // 获取首页配置信息
                getHomeData().then(res => {
                    if (res.code && res.code == 200) {
                        this.homeData = res.data
                    }
                })
                getBanner().then(res => {
                    if (res.code && res.code == 200) {
                        let noReadings = []
                        if (res.data.noReadings && res.data.noReadings.length > 0) {
                            res.data.noReadings.forEach(item => {
                                if (item.num > 0) {
                                    noReadings.push(item)
                                }
                            })
                        }
                        this.noReadings = noReadings
                        this.bannerObj.autoSwitch = res.data.autoSwitch == "false" ? false : true
                        this.bannerObj.intervalTime = parseInt(res.data.intervalTime) || 3000
                        this.bannerObj.items = res.data.items
                        this.bannerObj.height = parseInt(res.data.height) || 250
                        this.searchBar.qabotSwitch = res.data.qabotSwitch == "1" ? true : false
                        this.timer = setInterval(() => {
                            this.noticeActive < this.noReadings.length - 1
                                ? (this.noticeActive += 1)
                                : (this.noticeActive = 0)
                        }, 2000)
                    }
                })
                getUnreadMessageCount().then(res => {
                    if (res.code && res.code == 200) {
                        console.log(res.data)
                        this.noReading = res.data || 0
                    }
                })
            },
            //搜索点击事件
            searchHandle() {
                this.$router.push("/search")
            },
            //搜索框图标点击事件
            iconHandle() {
                locationTo("weixin/weui/qabot.html")
            },
            //通知点击事件
            noticeHandle() {
                this.$router.push({ path: "/messageList" })
            },
            // 页面滑动调用事件
            handleScroll() {
                let scrollTopE = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                const topPx = document.getElementById("swipeBanner").scrollHeight - 90
                if (scrollTopE > topPx) {
                    this.searchBar.hasBg = true
                } else {
                    this.searchBar.hasBg = false
                }
            },
        },
        destroyed() {
            document.removeEventListener("scroll", this.handleScroll)
        },
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/css/theme/theme.scss";
    .main-box {
        position: relative;
        z-index: 2;
        padding: 25px 15px 0;
        margin-top: -25px;
        border-radius: 25px 25px 0 0;
        background: #fff;

        .my-notice {
            position: absolute;
            top: -20px;
            right: 0;
            width: 190px;
            height: 40px;
            box-sizing: border-box;
            padding: 0 0 0 15px;
            border-radius: 20px 0 0 20px;
            color: #fff;
            line-height: 40px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;

            .iconfont {
                margin-right: 5px;
            }
        }
    }
</style>
